<template>
  <el-container class="layout">
    <el-aside width="210px" class="aside">
      <div class="logo">机动车服务综合平台</div>
      <el-menu
        :default-active="$route.path"
        :default-openeds="defaultOpens"
        router
        background-color="#263238"
        text-color="#c0c4cc"
        active-text-color="#409EFF"
        unique-opened
      >
        <template v-for="item in menuTree">
          <!-- 有子项：渲染 submenu -->
          <el-submenu v-if="item.children && item.children.length" :key="item.path" :index="item.path">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item v-for="c in item.children" :key="c.path" :index="c.path">
              <i v-if="c.icon" :class="c.icon"></i>
              <span slot="title">{{ c.title }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- 无子项：渲染普通 menu-item -->
          <el-menu-item v-else :key="item.path" :index="item.path">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header" height="50px">
        <div class="header-title">曲阜市机动车服务综合平台-管理后台</div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid"></i>
            {{ (userInfo && userInfo.realName) || (userInfo && userInfo.username) || '用户' }}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
const PARENT_MENUS = [
  { path: '/system', title: '系统管理', icon: 'el-icon-s-tools' }
]

export default {
  name: 'Layout',
  data() {
    return {
      defaultOpens: ['/system']
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    flatMenus() {
      const root = this.$router.options.routes.find(r => r.path === '/')
      return (root && root.children || [])
        .filter(r => r.meta && r.meta.title)
        .map(r => ({
          path: '/' + r.path,
          title: r.meta.title,
          icon: r.meta.icon,
          parentKey: r.meta.parentKey || null
        }))
    },
    menuTree() {
      const flat = this.flatMenus

      // 子路由按 parentKey 归集
      const childMap = {}
      flat.forEach(m => {
        if (m.parentKey) {
          if (!childMap[m.parentKey]) childMap[m.parentKey] = []
          childMap[m.parentKey].push({ path: m.path, title: m.title, icon: m.icon })
        }
      })

      // 收集所有父目录 key（meta 声明 + 自动推断）
      const parentKeys = new Set(Object.keys(childMap))

      // 构建父目录节点
      const parentNodes = PARENT_MENUS
        .filter(p => parentKeys.has(p.path))
        .map(p => ({
          path: p.path,
          title: p.title,
          icon: p.icon,
          children: childMap[p.path]
        }))

      // 顶层菜单：无 parentKey 的，加上父目录节点
      const topLevels = flat.filter(m => !m.parentKey)
      const result = topLevels.map(m => ({ path: m.path, title: m.title, icon: m.icon }))
      parentNodes.forEach(p => result.push(p))
      return result
    }
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$store.dispatch('user/logout').then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
}
</script>

<style scoped>
.layout { height: 100%; }
.aside { background: #263238; }
.logo {
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  background: #1f272c;
}
.aside .el-menu { border-right: none; }
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  background: #fff;
}
.header-title { font-size: 15px; font-weight: bold; color: #333; }
.el-dropdown-link { cursor: pointer; color: #409EFF; }
.main { background: #f0f2f5; padding: 12px; }
</style>
